const configPictogramOptions = [
  {
    code: 'config_pictogram_general',
    name: 'Configuración general',
    description: 'Permite configurar la configuración general del pictograma, como el nombre, la descripción, la imagen, etc.',
    icon: 'cog',
    order: 0,
    type: 'item',
    component: {
      name: 'PictogramConfig',
      props: {}
    }
  },
  {
    code: 'config_pictogram_activity_settings',
    name: 'Asignación a actividad',
    description: 'Gestionar asignación del pictograma a actividades.',
    icon: 'link',
    order: 1,
    type: 'item',
    component: {
      name: 'PictogramActivitySettings',
      props: {}
    }
  },
  {
    code: 'config_pictogram_geolocation',
    name: 'Configuración de geolocalización',
    description: 'Configurar geolocalización del pictograma.',
    icon: 'map-marker-alt',
    order: 2,
    type: 'item',
    component: {
      name: 'PictogramGeolocationSettings',
      props: {}
    }
  },
  {
    code: 'config_pictogram_boqs',
    name: 'Configuración de BOQs',
    description: 'Configurar BOQs del pictograma.',
    icon: 'file-invoice',
    order: 3,
    type: 'item',
    component: {
      name: 'PictogramBoqsSettings',
      props: {}
    }
  }
]


export { configPictogramOptions }
